// Customers
export const CUSTOMERS = '/';
export const CREATE_CUSTOMER = '/customer';